export const convertArrayToObject = (value: unknown[]) => value.reduce(
  (acc: { [key: string]: unknown }, optionValue: unknown) => {
    acc[optionValue as string] = true;
    return acc;
  }, {},
);
